module.exports = Stream;